import makeActionCreator from '../../utils/makeActionCreator'
import fetch from 'isomorphic-fetch'
import { sessionService } from 'redux-react-session';
import { browserHistory } from 'react-router'

import * as API       from '../../utils/config-api'
import * as endpoints from './endpoints'
import { logout } from '../../auth/list';

export const SETTINGS_RECRUITING_STAGES_PENDING = 'SETTINGS_RECRUITING_STAGES_PENDING'
export const settingsRecruitingStagesPending = makeActionCreator(SETTINGS_RECRUITING_STAGES_PENDING)

export const SETTINGS_RECRUITING_STAGES_REJECTED = 'SETTINGS_RECRUITING_STAGES_REJECTED'
export const settingsRecruitingStagesRejected = makeActionCreator(SETTINGS_RECRUITING_STAGES_REJECTED)

export const SETTINGS_RECRUITING_STAGES_SHOW_LIST= 'SETTINGS_RECRUITING_STAGES_SHOW_LIST'
export const settingsRecruitingStagesShowList = makeActionCreator(SETTINGS_RECRUITING_STAGES_SHOW_LIST)

export const SETTINGS_RECRUITING_STAGES_HIDE_LIST = 'SETTINGS_RECRUITING_STAGES_HIDE_LIST'
export const settingsRecruitingStagesHideList = makeActionCreator(SETTINGS_RECRUITING_STAGES_HIDE_LIST)

export const SETTINGS_RECRUITING_STAGES_SHOW_FORM= 'SETTINGS_RECRUITING_STAGES_SHOW_FORM'
export const settingsRecruitingStagesShowForm = makeActionCreator(SETTINGS_RECRUITING_STAGES_SHOW_FORM, 'itemId')

export const SETTINGS_RECRUITING_STAGES_HIDE_FORM = 'SETTINGS_RECRUITING_STAGES_HIDE_FORM'
export const settingsRecruitingStagesHideForm = makeActionCreator(SETTINGS_RECRUITING_STAGES_HIDE_FORM)

export const SETTINGS_RECRUITING_STAGES_SHOW_ITEM = 'SETTINGS_RECRUITING_STAGES_SHOW_ITEM'
export const settingsRecruitingStagesShowItem = makeActionCreator(SETTINGS_RECRUITING_STAGES_SHOW_ITEM, 'itemId')


//Show Index

export const SETTINGS_RECRUITING_STAGES_LIST_FULFILLED = 'SETTINGS_RECRUITING_STAGES_LIST_FULFILLED'
export const settingsRecruitingStagesListFulfilled = makeActionCreator(SETTINGS_RECRUITING_STAGES_LIST_FULFILLED, 'data')

export const SETTINGS_RECRUITING_STAGES_LIST_ERROR = 'SETTINGS_RECRUITING_STAGES_LIST_ERROR'
export const settingsRecruitingStagesListError = makeActionCreator(SETTINGS_RECRUITING_STAGES_LIST_ERROR, 'message')

export function settingsRecruitingStagesList() {

  return dispatch => {
    sessionService.loadSession().then(currentSession => {
      dispatch(settingsRecruitingStagesPending())

          return fetch(`${API.config.domain}${API.config.apiPreUrl}${endpoints.index.version}${endpoints.index.path}`, {
              method  : endpoints.index.method,
              headers : {
                  'Authorization' : `Bearer ${currentSession.token}`,
                  'Accept': 'application/json'
              }
          })
          .then( API.checkStatus )
          .then( API.parseJSON )
          .then( json => dispatch(settingsRecruitingStagesListFulfilled(json.data)) )
          .catch( err => {
              // Dispatch the error action with error information
              dispatch(settingsRecruitingStagesRejected(err))
          })
    })
    .catch(err => {
      dispatch(logout(() => browserHistory.push('/login')));

    })



  }
}


//Show Item

export const SETTINGS_RECRUITING_STAGES_ITEM_FULFILLED = 'SETTINGS_RECRUITING_STAGES_ITEM_FULFILLED'
export const settingsRecruitingStagesItemFulfilled = makeActionCreator(SETTINGS_RECRUITING_STAGES_ITEM_FULFILLED, 'data')

export const SETTINGS_RECRUITING_STAGES_ITEM_ERROR = 'SETTINGS_RECRUITING_STAGES_ITEM_ERROR'
export const settingsRecruitingStagesItemError = makeActionCreator(SETTINGS_RECRUITING_STAGES_ITEM_ERROR, 'message')

export function settingsRecruitingStagesItem(itemId) {

  return dispatch => {
    sessionService.loadSession().then(currentSession => {
      dispatch(settingsRecruitingStagesPending())

          return fetch(`${API.config.domain}${API.config.apiPreUrl}${endpoints.getItem.version}${endpoints.getItem.path.replace(":recruit_stages_id", itemId)}`, {
              method  : endpoints.getItem.method,
              headers : {
                  'Authorization' : `Bearer ${currentSession.token}`,
                  'Accept': 'application/json'
              }
          })
          .then( API.checkStatus )
          .then( API.parseJSON )
          .then( json => dispatch(settingsRecruitingStagesItemFulfilled(json.data)) )
          .catch( err => {
              // Dispatch the error action with error information
              dispatch(settingsRecruitingStagesRejected(err))
          })
    })
    .catch(err => {
      dispatch(logout(() => browserHistory.push('/login')));

    })



  }
}


//Add Item

export const SETTINGS_RECRUITING_STAGES_ITEM_ADD_FULFILLED = 'SETTINGS_RECRUITING_STAGES_ITEM_ADD_FULFILLED'
export const settingsRecruitingStagesItemAddFulfilled = makeActionCreator(SETTINGS_RECRUITING_STAGES_ITEM_ADD_FULFILLED, 'data')

export const SETTINGS_RECRUITING_STAGES_ITEM_ADD_ERROR = 'SETTINGS_RECRUITING_STAGES_ITEM_ADD_ERROR'
export const settingsRecruitingStagesItemAddError = makeActionCreator(SETTINGS_RECRUITING_STAGES_ITEM_ADD_ERROR, 'message')

export function settingsRecruitingStagesAddItem(data) {
  let formData = new FormData()

  Object.keys(data).map((key)=> {
    formData.append(key, data[key]);
    return key;
  });

  return dispatch => {
    sessionService.loadSession().then(currentSession => {
      dispatch(settingsRecruitingStagesPending())

          return fetch(`${API.config.domain}${API.config.apiPreUrl}${endpoints.addItem.version}${endpoints.addItem.path}`, {
              method  : endpoints.addItem.method,
              headers : {
                  'Authorization' : `Bearer ${currentSession.token}`,
                  'Accept': 'application/json'
              },
              body: formData
          })
          .then( API.checkStatus )
          .then( API.parseJSON )
          .then( json => {
              if(json.status === "ok"){
                dispatch(settingsRecruitingStagesItemAddFulfilled(json.data))
              }else{
                dispatch(settingsRecruitingStagesItemAddError(json.message))
              }
          } )
          .catch( err => {
              // Dispatch the error action with error information
              dispatch(settingsRecruitingStagesRejected(err))
          })
    })
    .catch(err => {
      dispatch(logout(() => browserHistory.push('/login')));

    })



  }
}

//Update Item

export const SETTINGS_RECRUITING_STAGES_ITEM_UPDATE_FULFILLED = 'SETTINGS_RECRUITING_STAGES_ITEM_UPDATE_FULFILLED'
export const settingsRecruitingStagesItemUpdateFulfilled = makeActionCreator(SETTINGS_RECRUITING_STAGES_ITEM_UPDATE_FULFILLED, 'data')

export const SETTINGS_RECRUITING_STAGES_ITEM_UPDATE_ERROR = 'SETTINGS_RECRUITING_STAGES_ITEM_UPDATE_ERROR'
export const settingsRecruitingStagesItemUpdateError = makeActionCreator(SETTINGS_RECRUITING_STAGES_ITEM_UPDATE_ERROR, 'message')

export function settingsRecruitingStagesUpdateItem(itemId, data) {
  let formData = new FormData()
  formData.append('_method', 'PUT')

  Object.keys(data).map((key)=> {
    formData.append(key, data[key]);
    return key;
  });


  return dispatch => {
    sessionService.loadSession().then(currentSession => {
      dispatch(settingsRecruitingStagesPending())

          return fetch(`${API.config.domain}${API.config.apiPreUrl}${endpoints.updateItem.version}${endpoints.updateItem.path.replace(":recruit_stages_id", itemId)}`, {
              method  : endpoints.updateItem.method,
              headers : {
                  'Authorization' : `Bearer ${currentSession.token}`,
                  'Accept': 'application/json'
              },
              body: formData
          })
          .then( API.checkStatus )
          .then( API.parseJSON )
          .then( json => {
              if(json.status === "ok"){
                dispatch(settingsRecruitingStagesItemUpdateFulfilled(json.data))
              }else{
                dispatch(settingsRecruitingStagesItemUpdateError(json.message))
              }
          } )
          .catch( err => {
              // Dispatch the error action with error information
              dispatch(settingsRecruitingStagesRejected(err))
          })
    })
    .catch(err => {
      dispatch(logout(() => browserHistory.push('/login')));

    })



  }
}

//Delete Item

export const SETTINGS_RECRUITING_STAGES_ITEM_DELETE_FULFILLED = 'SETTINGS_RECRUITING_STAGES_ITEM_DELETE_FULFILLED'
export const settingsRecruitingStagesItemDeleteFulfilled = makeActionCreator(SETTINGS_RECRUITING_STAGES_ITEM_DELETE_FULFILLED, 'data')

export const SETTINGS_RECRUITING_STAGES_ITEM_DELETE_ERROR = 'SETTINGS_RECRUITING_STAGES_ITEM_DELETE_ERROR'
export const settingsRecruitingStagesItemDeleteError = makeActionCreator(SETTINGS_RECRUITING_STAGES_ITEM_DELETE_ERROR, 'message')

export function settingsRecruitingStagesDeleteItem(itemId) {

  return dispatch => {
    sessionService.loadSession().then(currentSession => {
      dispatch(settingsRecruitingStagesPending())

          return fetch(`${API.config.domain}${API.config.apiPreUrl}${endpoints.deleteItem.version}${endpoints.deleteItem.path.replace(":recruit_stages_id", itemId)}`, {
              method  : endpoints.deleteItem.method,
              headers : {
                  'Authorization' : `Bearer ${currentSession.token}`,
                  'Accept': 'application/json'
              }
          })
          .then( API.checkStatus )
          .then( API.parseJSON )
          .then( json => {
            if(json.status === "ok"){
              dispatch(settingsRecruitingStagesItemDeleteFulfilled(json.data))
              dispatch(settingsRecruitingStagesList())
            }else{
              dispatch(settingsRecruitingStagesItemDeleteError(json.message))
            }

          })
          .catch( err => {
              // Dispatch the error action with error information
              dispatch(settingsRecruitingStagesRejected(err))
          })
    })
    .catch(err => {
      dispatch(logout(() => browserHistory.push('/login')));

    })





  }
}
